// import * as React from 'react';
// import { AuthConsumer } from '../helpers/AuthContext'
// import Navbar from 'react-bootstrap/Navbar'
// import Container from 'react-bootstrap/Container'
// import Offcanvas from 'react-bootstrap/Offcanvas'
// import Nav from 'react-bootstrap/Nav'
// import icmobi from '../logos/ICMOBI_logoArtboard_1.svg'

// const ResponsiveAppBar = () => {

//     return (
//         <AuthConsumer>
//             {({Auth, Name}) => {

//                 if (Auth === 'Admin') {
//                     return (
//                         <Navbar bg="light" fixed="top" expand={false}>
//                             <Container fluid>
//                                 <Navbar.Brand href="/">
//                                     <img src={icmobi} alt="ICMOBI logo" height="50px" style={{paddingLeft: '10%'}}/>
//                                 </Navbar.Brand>
//                                 <Nav className="flex-row">
//                                     <Nav.Link className="mx-5" href="/label">Label</Nav.Link>
//                                     <Nav.Link className="mx-5" href="/results">Leaderboard</Nav.Link>
//                                 </Nav>

//                                 <Navbar.Toggle aria-controls="offcanvasNavbar" />
//                                 <Navbar.Offcanvas
//                                     id="offcanvasNavbar"
//                                     aria-labelledby="offcanvasNavbarLabel"
//                                     placement="end"
//                                 >
//                                 <Offcanvas.Header closeButton>
//                                     <Offcanvas.Title id="offcanvasNavbarLabel">Hi {Name}</Offcanvas.Title>
//                                 </Offcanvas.Header>
//                                     <Offcanvas.Body>
//                                         <Nav className="justify-content-end flex-grow-1 pe-3">
//                                             <Nav.Link href="/dashboard">Dashboard{labDot}</Nav.Link>
//                                             <Nav.Link href="/users">Users</Nav.Link>
//                                             <Nav.Link href="/datalist">Data</Nav.Link>
//                                             <Nav.Link href="/statistics">Statistics</Nav.Link>
//                                             <Nav.Link href="/logout">Logout</Nav.Link>
//                                         </Nav>
//                                     </Offcanvas.Body>
//                                 </Navbar.Offcanvas>
//                             </Container>
//                         </Navbar>
//                     )
//                 }

//                 else if (Auth === 'User') {
//                     return (
//                         <Navbar bg="light" fixed="top" expand={false}>
//                             <Container fluid>
//                                 <Navbar.Brand href="/">
//                                     <img src={icmobi} alt="ICMOBI logo" height="50px" style={{paddingLeft: '10%'}}/>
//                                 </Navbar.Brand>
//                                 <Nav className="flex-row">
//                                     <Nav.Link className="mx-5" href="/label">Label</Nav.Link>
//                                     <Nav.Link className="mx-5" href="/results">Leaderboard</Nav.Link>
//                                 </Nav>

//                                 <Navbar.Toggle aria-controls="offcanvasNavbar" />
//                                 <Navbar.Offcanvas
//                                     id="offcanvasNavbar"
//                                     aria-labelledby="offcanvasNavbarLabel"
//                                     placement="end"
//                                 >
//                                 <Offcanvas.Header closeButton>
//                                     <Offcanvas.Title id="offcanvasNavbarLabel">Hi {Name}</Offcanvas.Title>
//                                 </Offcanvas.Header>
//                                     <Offcanvas.Body>
//                                         <Nav className="justify-content-end flex-grow-1 pe-3">
//                                             <Nav.Link href="/dashboard">Dashboard{labDot}</Nav.Link>
//                                             <Nav.Link href="/logout">Logout</Nav.Link>
//                                         </Nav>
//                                     </Offcanvas.Body>
//                                 </Navbar.Offcanvas>
//                             </Container>
//                         </Navbar>
//                     )
//                 }

//                 else {
//                     return (
//                         <Navbar bg="light" fixed="top" expand={false}>
//                             <Container fluid>
//                                 <Navbar.Brand href="/">
//                                     <img src={icmobi} alt="ICMOBI logo" height="50px" style={{paddingLeft: '10%'}}/>
//                                 </Navbar.Brand>
//                                 <Nav className="flex-row">
//                                     <Nav.Link className="mx-5" href="/label">Label</Nav.Link>
//                                     <Nav.Link className="mx-5" href="/results">Leaderboard</Nav.Link>
//                                 </Nav>

//                                 <Navbar.Toggle aria-controls="offcanvasNavbar" />
//                                 <Navbar.Offcanvas
//                                     id="offcanvasNavbar"
//                                     aria-labelledby="offcanvasNavbarLabel"
//                                     placement="end"
//                                 >
//                                 <Offcanvas.Header closeButton>
//                                     <Offcanvas.Title id="offcanvasNavbarLabel">Hi {Name}</Offcanvas.Title>
//                                 </Offcanvas.Header>
//                                     <Offcanvas.Body>
//                                         <Nav className="justify-content-end flex-grow-1 pe-3">
//                                             <Nav.Link href="/signup">Signup</Nav.Link>
//                                             <Nav.Link href="/login">Login</Nav.Link>
//                                         </Nav>
//                                     </Offcanvas.Body>
//                                 </Navbar.Offcanvas>

//                             </Container>
//                         </Navbar>
//                         )
//                     }
//             }}

//         </AuthConsumer>
//     );
// }

// export default ResponsiveAppBar;
import React from "react";
import { AuthConsumer } from "../helpers/AuthContext";
import Navbar from "react-bootstrap/Navbar";
import Container from "react-bootstrap/Container";
import Offcanvas from "react-bootstrap/Offcanvas";
import Nav from "react-bootstrap/Nav";
import icmobi from "../logos/ICMOBI_logoArtboard_1.svg";
import "../styles/navbarModern.css"; // NEW THEME FILE

// Admin-tool destinations, shown identically on desktop (dropdown) and
// mobile (drawer) so the two navs stay at parity.
const ADMIN_LINKS = [
  ["/admin/quality", "Quality"],
  ["/admin/labs", "Labs"],
  ["/users", "Users"],
  ["/datalist", "Data"],
  ["/statistics", "Statistics"],
];

const ResponsiveAppBar = () => {
  const [profileOpen, setProfileOpen] = React.useState(false);
  const [adminOpen, setAdminOpen] = React.useState(false);

  // Close popover on outside click
  React.useEffect(() => {
    if (!profileOpen) return;
    const handler = (e) => {
      if (!e.target.closest(".profile-chip-wrap")) setProfileOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [profileOpen]);

  // Close the admin dropdown on outside click
  React.useEffect(() => {
    if (!adminOpen) return;
    const handler = (e) => {
      if (!e.target.closest(".admin-menu-wrap")) setAdminOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [adminOpen]);

  return (
    <AuthConsumer>
      {({ Auth, Name, Email, ProfileComplete, Lab, LabNoticeDismissed }) => {
        const isLoggedIn = Auth === "Admin" || Auth === "User";
        // A logged-in user whose profile isn't finished is locked to
        // /complete-profile by RouteGuard — so showing Home/Label/Dashboard
        // would just be dead links that bounce. Show only the profile link.
        const incompleteProfile = isLoggedIn && ProfileComplete === false;
        // Nudge dot on Dashboard: logged-in user who hasn't set a lab and
        // hasn't chosen "I'm not in a lab".
        const needsLab =
          isLoggedIn &&
          !incompleteProfile &&
          !(Lab && String(Lab).trim()) &&
          !LabNoticeDismissed;
        const firstInitial =
          Name && Name.trim().length ? Name.trim()[0].toUpperCase() : "U";
        const labDot = needsLab ? (
          <span
            title="Set your research lab"
            style={{
              display: "inline-block",
              width: 8,
              height: 8,
              borderRadius: "50%",
              background: "#ef4444",
              marginLeft: 6,
              verticalAlign: "middle",
            }}
          />
        ) : null;

        return (
          <Navbar fixed="top" expand="md" className="modern-nav">
            <Container fluid>
              {/* Left Logo + waveform glyph */}
              <Navbar.Brand href="/" className="nav-logo-area">
                <img src={icmobi} alt="ICMOBI logo" className="nav-logo" />
                <span className="nav-glyph" aria-hidden="true">
                  <svg viewBox="0 0 42 16" preserveAspectRatio="none">
                    <path d="M0 8 L4 8 L6 4 L8 12 L10 6 L12 10 L14 8 L18 8 L20 3 L22 13 L24 5 L26 11 L28 8 L32 8 L34 6 L36 10 L38 7 L42 8" />
                  </svg>
                </span>
                <span className="nav-brand-name">EEG // LABEL</span>
              </Navbar.Brand>

              {/* Center Navigation */}
              <div className="nav-center d-none d-md-flex">
                {incompleteProfile ? (
                  <Nav.Link href="/complete-profile" className="nav-link-modern">
                    Complete your profile
                  </Nav.Link>
                ) : (
                  <>
                    <Nav.Link href="/" className="nav-link-modern">
                      Home
                    </Nav.Link>
                    <Nav.Link href="/label" className="nav-link-modern">
                      Label
                    </Nav.Link>
                    <Nav.Link href="/results" className="nav-link-modern">
                      Leaderboard
                    </Nav.Link>

                    {/* Dashboard for logged-in users */}
                    {isLoggedIn && (
                      <Nav.Link href="/dashboard" className="nav-link-modern">
                        Dashboard
                        {labDot}
                      </Nav.Link>
                    )}

                    {/* Admin tools — dropdown at desktop parity with the
                        mobile drawer (Quality/Users/Data/Statistics). */}
                    {Auth === "Admin" && (
                      <div
                        className="admin-menu-wrap"
                        style={{ position: "relative" }}
                      >
                        <button
                          type="button"
                          className="nav-link-modern"
                          onClick={() => setAdminOpen((v) => !v)}
                          style={{
                            background: "transparent",
                            border: "none",
                            cursor: "pointer",
                            font: "inherit",
                          }}
                        >
                          Admin {adminOpen ? "▴" : "▾"}
                        </button>
                        {adminOpen && (
                          <div
                            style={{
                              position: "absolute",
                              top: "calc(100% + 8px)",
                              left: 0,
                              minWidth: 180,
                              padding: 6,
                              background: "#ffffff",
                              border: "1px solid rgba(8, 145, 178, 0.22)",
                              borderRadius: 12,
                              boxShadow: "0 10px 30px rgba(15, 23, 42, 0.12)",
                              zIndex: 1000,
                              display: "flex",
                              flexDirection: "column",
                            }}
                          >
                            {ADMIN_LINKS.map(([href, label]) => (
                              <a
                                key={href}
                                href={href}
                                style={{
                                  padding: "8px 12px",
                                  borderRadius: 8,
                                  color: "#0a0e1a",
                                  textDecoration: "none",
                                  fontSize: 14,
                                  fontFamily: "Poppins, sans-serif",
                                }}
                              >
                                {label}
                              </a>
                            ))}
                          </div>
                        )}
                      </div>
                    )}
                  </>
                )}
              </div>

              {/* Right Profile */}
              <div className="nav-right d-none d-md-flex">
                {isLoggedIn ? (
                  <>
                    <div
                      className="profile-chip-wrap"
                      style={{ position: "relative" }}
                    >
                      <button
                        type="button"
                        onClick={() => setProfileOpen((v) => !v)}
                        className="profile-chip"
                        style={{
                          background: "transparent",
                          border: "1px solid rgba(8, 145, 178, 0.2)",
                          cursor: "pointer",
                        }}
                        title="Click to view email"
                      >
                        <div className="profile-avatar">{firstInitial}</div>
                        <span className="profile-name">{Name}</span>
                      </button>
                      {profileOpen && (
                        <div
                          style={{
                            position: "absolute",
                            top: "calc(100% + 8px)",
                            right: 0,
                            minWidth: 240,
                            padding: "14px 16px",
                            background: "#ffffff",
                            border: "1px solid rgba(8, 145, 178, 0.22)",
                            borderRadius: 12,
                            boxShadow: "0 10px 30px rgba(15, 23, 42, 0.12)",
                            zIndex: 1000,
                            fontFamily: "Poppins, sans-serif",
                          }}
                        >
                          <div
                            style={{
                              fontSize: 10,
                              fontWeight: 600,
                              letterSpacing: "0.14em",
                              textTransform: "uppercase",
                              color: "#6b7280",
                              marginBottom: 4,
                            }}
                          >
                            Signed in as
                          </div>
                          <div
                            style={{
                              fontSize: 14,
                              fontWeight: 600,
                              color: "#0a0e1a",
                              marginBottom: 2,
                            }}
                          >
                            {Name}
                          </div>
                          <div
                            style={{
                              fontSize: 13,
                              color: "#0891b2",
                              wordBreak: "break-all",
                            }}
                          >
                            {Email}
                          </div>
                          <div
                            style={{
                              marginTop: 10,
                              paddingTop: 10,
                              borderTop: "1px dashed rgba(8, 145, 178, 0.18)",
                              fontSize: 11,
                              color: "#6b7280",
                              textTransform: "uppercase",
                              letterSpacing: "0.08em",
                            }}
                          >
                            Role: {Auth}
                          </div>
                          <a
                            href="/complete-profile"
                            style={{
                              display: "block",
                              marginTop: 12,
                              padding: "8px 12px",
                              textAlign: "center",
                              borderRadius: 8,
                              background: "rgba(8, 145, 178, 0.08)",
                              color: "#0891b2",
                              textDecoration: "none",
                              fontSize: 13,
                              fontWeight: 600,
                            }}
                          >
                            Edit profile
                          </a>
                        </div>
                      )}
                    </div>
                    <a href="/logout" className="btn-nav-primary">
                      Logout
                    </a>
                  </>
                ) : (
                  <>
                    <a href="/login" className="btn-nav-outline">
                      Login
                    </a>
                    <a href="/signup" className="btn-nav-primary">
                      Sign Up
                    </a>
                  </>
                )}
              </div>

              {/* Mobile Toggle */}
              <Navbar.Toggle className="nav-toggle d-md-none" />

              {/* Mobile Drawer */}
              <Navbar.Offcanvas
                placement="end"
                className="mobile-menu"
                id="offcanvas"
              >
                <Offcanvas.Header closeButton>
                  <Offcanvas.Title className="mobile-title">
                    {isLoggedIn ? `Hi, ${Name}` : "Menu"}
                  </Offcanvas.Title>
                </Offcanvas.Header>

                <Offcanvas.Body>
                  <Nav className="flex-column mobile-links">
                    {incompleteProfile ? (
                      <Nav.Link href="/complete-profile">
                        Complete your profile
                      </Nav.Link>
                    ) : (
                      <>
                        <Nav.Link href="/">Home</Nav.Link>
                        <Nav.Link href="/label">Label</Nav.Link>
                        <Nav.Link href="/results">Leaderboard</Nav.Link>

                        {Auth === "Admin" && (
                          <>
                            <Nav.Link href="/dashboard">Dashboard{labDot}</Nav.Link>
                            {ADMIN_LINKS.map(([href, label]) => (
                              <Nav.Link key={href} href={href}>
                                {label}
                              </Nav.Link>
                            ))}
                          </>
                        )}

                        {Auth === "User" && (
                          <Nav.Link href="/dashboard">Dashboard{labDot}</Nav.Link>
                        )}

                        {isLoggedIn && (
                          <Nav.Link href="/complete-profile">
                            Edit profile
                          </Nav.Link>
                        )}
                      </>
                    )}
                  </Nav>

                  {/* Mobile Auth Section */}
                  <div className="mobile-auth">
                    {isLoggedIn ? (
                      <>
                        <div className="profile-chip mobile-chip">
                          <div className="profile-avatar">{firstInitial}</div>
                          <span>{Name}</span>
                        </div>

                        <a href="/logout" className="btn-nav-primary w-100">
                          Logout
                        </a>
                      </>
                    ) : (
                      <>
                        <a
                          href="/login"
                          className="btn-nav-outline w-100 mb-2 text-center"
                        >
                          Login
                        </a>
                        <a
                          href="/signup"
                          className="btn-nav-primary w-100 text-center"
                        >
                          Sign Up
                        </a>
                      </>
                    )}
                  </div>
                </Offcanvas.Body>
              </Navbar.Offcanvas>
            </Container>
          </Navbar>
        );
      }}
    </AuthConsumer>
  );
};

export default ResponsiveAppBar;
